module.exports = __webpack_public_path__ + "img/access-freedom.23c14216.svg";